module.exports = "<div class=resource-progress-card> <div class=resource-background-color> <div class=q-text-center> <i class=\"fa resource-icon q-fs-lg\"> </i> </div> </div> <div class=resource-progress-content> <div class=resource-content-pad> <h4 class=resource-title> </h4> <span class=resource-timestamp> </span> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/resourceProgress/html/resourceProgressCard.html
// module id = 1167
// module chunks = 1